import React, {useState,useEffect,useMemo} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import Loader from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import { updatePhoneNumbers, getPhoneNumbers } from '../Redux/AccountSettings/AccountSettingsActions';


function PhoneNumbers() {
  const dispatch = useDispatch();
  const [phoneNumberData, setPhoneNumberData] = useState();
  const accountSettingsData = useSelector(state =>state.AccountSettings);
  const [error,setError] = useState(null);

    const [inputValues,setInputValues] = useState({
                 sms_phone:"",
                 fax_number:"",
                 merchant_contact:""
      });

    // fetch allBook  api hook start
      useEffect(() =>{
        dispatch(getPhoneNumbers())
      },[dispatch])
      // fetch allBook api hook End
    
      useMemo(() =>{
        if(accountSettingsData && accountSettingsData.get_phone_numbers && accountSettingsData.get_phone_numbers.object){
          setInputValues(accountSettingsData.get_phone_numbers.object)
        }
      },[accountSettingsData])


      
  // examHandler function start
    const addPhoneNumbersHandler = (event) =>{
      event.preventDefault()
      dispatch(updatePhoneNumbers(inputValues.sms_phone, inputValues.fax_number, inputValues.merchant_contact));
   }
 // examHandler function End
 
 // resetHandler function start
    const resetHandler = (event) =>{
      event.preventDefault()
      window.location.reload(false);
    }
 // resetHandler function End

        return (           
          <>
          <div className="breadcrumbs-area">
            <h3>Phone Numbers</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Phone Numbers</li>
            </ul>
          </div>
            {/* Breadcubs Area Start Here */}
            <div className="row dashboard-card-six">

        {/* <div className="card-body">
          <div className="heading-layout1 mg-b-17">
            <div className="item-title">
              <h3>Phone Numbers</h3>
            </div>

          </div>
          
          <div className='row'>
             <div class="col-xl-6 col-sm-12 col-12">
               <div class="card">
                 <div class="card-content">
                   <div class="card-body">
                     <div class="media d-flex">
                                    
                       <div class="media-body" style={{fontWeight:"bold"}}>
                          <div className="item-number">SMS Phone:</div>
                          {phoneNumberData && <div className="item-number">{phoneNumberData.sms_phone}</div>}
                       </div>

                     </div>
                   </div>
                 </div>
              </div>
            </div>

            <div class="col-xl-6 col-sm-12 col-12">
               <div class="card">
                 <div class="card-content">
                   <div class="card-body">
                     <div class="media d-flex">
                                    
                       <div class="media-body" style={{fontWeight:"bold"}}>
                          <div className="item-number">Fax Number:</div>
                          {phoneNumberData && <div className="item-number">{phoneNumberData.fax_number}</div>}
                       </div>

                     </div>
                   </div>
                 </div>
              </div>
            </div>

            <div class="col-xl-6 col-sm-12 col-12">
               <div class="card">
                 <div class="card-content">
                   <div class="card-body">
                     <div class="media d-flex">
                                    
                       <div class="media-body" style={{fontWeight:"bold"}}>
                          <div className="item-number">Merchant Contact Number:</div>
                          {phoneNumberData && <div className="item-number">{phoneNumberData.merchant_contact}</div>}
                       </div>

                     </div>
                   </div>
                 </div>
              </div>
            </div>

          </div>

        </div>
                 */}
                
                
        <div className="col-6-xxxl col-12">
                <div className="card height-auto">

                {accountSettingsData.is_loading === true ? (<div className="card-body">
                      <div className="Student-Loader">
                      <Loader
                      className = "student-detail-loader"
                    type="MutatingDots"
                    color="#fea801"
                    height={150}
                    width={150}
                   />
                      </div>
                    </div>)
                   :
                  (<div className="card-body">
                    
                    <div className="heading-layout1 bg-darkblue">
                      <div className="item-title">
                        <h3 className='text-light'>Add Phone Numbers</h3>
                        
                      </div>
                    </div>

                    {accountSettingsData.phone_numbers && accountSettingsData.phone_numbers.request_status === true ? (<div className="success-greeting1">
                        <h2 className="addtimesuccess">Phone Numbers Added Successfully!</h2>
                        </div>): null}
                        {accountSettingsData.get_error && accountSettingsData.get_error.object && accountSettingsData.get_error.object.error ? (<div className="success-greeting1">

                        <h2 className="addtimeerror">{accountSettingsData.get_error.object.error}</h2>
                        </div>): null}
                    
                    <form className="new-added-form" onSubmit={(e) =>addPhoneNumbersHandler(e)}>
                      <div className="row">
                        
                        <div className="col-12-xxxl col-lg-6 col-12 form-group">
                          <label>SMS Phone *</label>
                          <input type="text" placeholder className="form-control" value={inputValues.sms_phone} onChange={(e) =>setInputValues({...inputValues,sms_phone:e.target.value})} required/>
                          {error != null && error.sms_phone ? (<h6 className="addStudent-error">*{JSON.stringify(error.sms_phone).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>

                        <div className="col-12-xxxl col-lg-6 col-12 form-group">
                          <label>Fax Number *</label>
                          <input type="text" placeholder className="form-control" value={inputValues.fax_number} onChange={(e) =>setInputValues({...inputValues,fax_number:e.target.value})} required/>
                          {error != null && error.fax_number ? (<h6 className="addStudent-error">*{JSON.stringify(error.fax_number).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>

                        <div className="col-12-xxxl col-lg-6 col-12 form-group">
                          <label>Merchant Contact Number *</label>
                          <input type="text" placeholder className="form-control" value={inputValues.merchant_contact} onChange={(e) =>setInputValues({...inputValues,merchant_contact:e.target.value})} required/>
                          {error != null && error.merchant_contact ? (<h6 className="addStudent-error">*{JSON.stringify(error.merchant_contact).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>

                        <div className="col-12 form-group mg-t-8" style={{paddingTop:"20px"}}>
                          <button type="submit" style={{marginLeft:"10px"}} className="btn-fill-lg bg-blue-dark btn-hover-yellow right-float">Save</button>
                          <button type="reset" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark right-float" onClick={(e) =>resetHandler(e)}>Reset</button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                </div>
              </div>




            </div>
          </>       
        );
}

export default PhoneNumbers;
